
/// <amd-module name="WorkItemsHub/Utils/ColumnOptionsPanelContracts" />
/**
 * Partial support of FieldDefinition class 
 * Used by ColumnOptionsPanel
 */

import * as Utils_String from "VSS/Core/Util/String";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";

export class LegacyFieldDefinition {
    public id: number;
    public name: string;
    public referenceName: string;
    public canSort: boolean;
    public canQuery: boolean;

    public canSortBy(): boolean {
        return this.canSort;
    }

    public isQueryable(): boolean {
        return this.canQuery;
    }

    public isIgnored(): boolean {
        if (Utils_String.equals(this.referenceName, CoreFieldRefNames.AreaId, true)
            || Utils_String.equals(this.referenceName, CoreFieldRefNames.IterationId, true)) {
            return true;
        }

        return false;
    }

}

/**
 * Represents the result passed to the caller when user clicks OK in a column options dialog/panel.
 */
export interface IColumnOptionsResult {
    display: IDisplayColumnResult[];
    sort: IDisplayColumnResult[];
    async?: boolean;
    added?: string[];
    removed?: string[];
}

export interface IDisplayColumnResult {
    id: number;
    name?: string;
    text: string;
    width?: number;
    asc?: boolean;
}
